import React, { Component } from 'react';
import './LoginForm.css';

export default class GenerateNewOTPComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
        this.generateOTP = this.generateOTP.bind(this);
    }


    generateOTP() {

        this.props.changeValueState();

        fetch('generateOtp', {
            method: 'POST',
            redirect: 'follow',
            headers: new Headers({
                'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            credentials: 'include',
        }).then(function (response) {
            console.log(response);
        }).catch(err => console.error('Caught error: ', err));
    }


    render() {
        console.log("it is: ", this.props.valueOfGenerateOTP)

        if (this.props.valueOfGenerateOTP) {
            return (
                <div>
                    <button onClick={this.generateOTP} className='connectButton' >
                        {this.props.composingLabel('sportOauthLabel.generateNewOtp', 'Generate New OTP')}
                    </button>
                </div>
            )
        } else {
            return (
                <div>
                </div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/resources/js/components/GenerateNewOTPComponent.js